import { Guid } from '@/utils/guid'
import { getFormatMessage } from '@/utils/utils'
import { FileOutlined } from '@ant-design/icons'
import { Button, Col, Form, Input, message, Row, Upload } from 'antd'
import { RcFile } from 'antd/lib/upload'
import React, { useEffect, useState } from 'react'
import { TemplateImportProps, TemplateItem } from '../interface'

export const TemplateImport: React.FC<TemplateImportProps> = (
  props: TemplateImportProps
) => {
  const [selectFile, setSelectFile] = useState<string>('')
  const [fileList, setFileList] = useState<RcFile[]>([])
  const formatMessage = getFormatMessage()
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 }
    }
  }

  const parse = (context: string): TemplateItem | null => {
    try {
      const item: TemplateItem = JSON.parse(context)
      item.id = Guid.raw()
      item.applied = false
      if (!item.name || item.name === '') {
        message.error(
          formatMessage({ id: 'app.template.import.error.emptyName' })
        )
        return null
      }
      return item
    } catch (err) {
      message.error(formatMessage({ id: 'app.template.import.error.format' }))
      return null
    }
  }

  const uploadProps = {
    showUploadList: false,
    multiple: true,
    accept: '.json',
    fileList: fileList,
    beforeUpload: async (file: RcFile, fileList: RcFile[]) => {
      setSelectFile(file.name)
      setFileList(fileList)
      return false
    }
  }

  const importTemplate = async () => {
    if (!props.onImport) return
    if (fileList.length <= 0) return
    const items: TemplateItem[] = []
    for (const file of fileList) {
      const text = await file.text()
      const item = parse(text)
      console.log(item)
      if (item) {
        items.push(item)
      }
    }
    props.onImport(items)
  }

  useEffect(() => {
    if (props.formResult) {
      importTemplate()
    }
  }, [props.formResult])

  return (
    <div>
      <Form {...formItemLayout}>
        <Form.Item
          name='selectFile'
          label={formatMessage({ id: 'app.box.import.selectFile' })}
        >
          <Row gutter={8}>
            <Col span={18}>
              <Input placeholder='' value={selectFile} />
            </Col>
            <Col span={4}>
              <Upload {...uploadProps}>
                <Button type='primary' icon={<FileOutlined />} />
              </Upload>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </div>
  )
}
